<template>
        <div id="second-section" class="rounded-wrapper bg-white position-relative">
            <div class="container">
                <div class="row">
                    <div class="col-md-4 d-flex justify-content-end flex-column align-items-end pb-5"
                        style="margin-top: -60px;">
                        <!-- <img v-on:click="changeImage" class="d-none d-md-block mx-1 my-2 img-fluid clickable-image"
                            style="max-height: 200px;" src="images/slide-2.png" alt="Whitepaper">
                        <img v-on:click="changeImage" class="d-none d-md-block mx-1 my-2 img-fluid clickable-image"
                            style="max-height: 200px;" src="images/slide-3.png" alt="Whitepaper"> -->
                        <template v-for="item in ipadImages">
                            <img v-on:click="changeImage" class="d-none d-md-block mx-1 my-2 img-fluid clickable-image"
                                style="max-height: 200px;" :src="item.imageSrc" alt="Whitepaper" v-bind:key="item.id">
                        </template>
                        
                        </div>
                    <div class="col-md-4" style="margin-top: -60px;">
                        <div class="d-none d-md-block position-relative h-100 pb-5">
                            <img id="largeImage" class="mw-100" :src="largeImageSrc" alt="Whitepaper">
                        </div>
                        <carousel class="mx-3 mb-3 d-md-none" :per-page="1" :center-mode="true">
                            <slide>
                                <img class="w-100" src="images/whitepaper-preview/Tablet1_EN.png" alt="Whitepaper">
                            </slide>
                            <slide>
                                <img class="w-100" src="images/whitepaper-preview/Tablet2_EN.png" alt="Whitepaper">
                            </slide>
                            <slide>
                                <img class="w-100" src="images/whitepaper-preview/Tablet3_EN.png" alt="Whitepaper">
                            </slide>
                        </carousel>
                    </div>
                    <div class="col-md-4">
                        <div
                            class="d-flex justify-content-center align-items-center align-items-md-start flex-column h-100">
                            <div class="d-flex align-items-center align-items-md-start flex-column mb-5">
                                <p class="text-black text-center text-md-left mb-4"><strong>Learn all about the
                                        questions:</strong></p>
                                <p class="text-black text-center text-md-left mb-4">How do I become a FROSIO
                                    inspector?<br /><br />What qualifications do I need?<br /><br />What are the
                                    advantages of e-learning?</p>
                                <a href="/whitepaper"
                                    class="btn btn-outline-primary text-uppercase font-weight-bold">
                                    Download now</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

</template>

<style lang="scss" scoped>
@import 'resources/sass/_variables.scss';

</style>

<script>

    export default {
        data: function () {
            return {
                largeImageSrc: "images/whitepaper-preview/Tablet1_EN.png",
                ipadImages: [
                    {
                        imageSrc: "images/whitepaper-preview/Tablet2_EN.png"
                    },
                    {
                        imageSrc: "images/whitepaper-preview/Tablet3_EN.png"
                    },
                ],
                spinning: false
            }
        },
        mounted() {
            setTimeout(() => this.spinning = true, 3000);
        },
        methods: {
            changeImage: function (event) {
                this.largeImageSrc = event.target.src;
            }
        }
    }
</script>
